import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Lockup } from './Brand';
import { session } from '../services/auth';
import { logout } from '../services/endpoints/auth';
import './Layout.css';

const NAV = [
  { num: '01', label: 'Overview',      to: '/' },
  { num: '02', label: 'Audio (Ifa)',   to: '/media' },
  { num: '03', label: 'Video',        to: '/videos' },
  { num: '04', label: 'Classes',       to: '/classes' },
  { num: '05', label: 'Creators',      to: '/creators' },
  { num: '06', label: 'Payouts',       to: '/payouts' },
  { num: '07', label: 'Users',         to: '/users' },
  { num: '08', label: 'Moderation',    to: '/moderation' },
  { num: '09', label: 'Broadcasts',    to: '/broadcasts' },
  { num: '10', label: 'Requests',      to: '/requests' },
  { num: '11', label: 'Cache',         to: '/cache' },
  { num: '12', label: 'Audit log',     to: '/audit' },
  { num: '13', label: 'Accounts',      to: '/accounts' },
  { num: '14', label: 'Settings',      to: '/settings' },
  { num: '15', label: 'Watermark',     to: '/watermark' },
  { num: '16', label: 'Fraud',         to: '/fraud' },
  { num: '17', label: 'Playback errors', to: '/playback-errors' },
];

export function Layout() {
  const nav = useNavigate();
  const user = session.user;
  const isAdmin = session.isAdmin();

  async function handleSignOut() {
    await logout();
    nav('/login', { replace: true });
  }

  return (
    <div className="nb-shell">
      <aside className="nb-sidebar">
        <div className="nb-sidebar__brand">
          <Lockup size={26} />
        </div>
        <nav className="nb-sidebar__nav">
          {NAV.map(item => {
            // Hide admin-only routes for non-admins
            const adminOnly = ['/users', '/moderation', '/broadcasts', '/requests', '/cache', '/audit', '/accounts', '/settings', '/watermark', '/fraud', '/playback-errors'];
            if (adminOnly.includes(item.to) && !isAdmin) return null;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) => `nb-nav__item ${isActive ? 'is-active' : ''}`}
              >
                <span className="nb-nav__num">{item.num}</span>
                <span className="nb-nav__label">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="nb-sidebar__foot">
          <div className="nb-sidebar__user">
            <div className="nb-sidebar__email" title={user?.email}>{user?.email || '—'}</div>
            <div className="nb-sidebar__role">{(user?.roles || []).join(' · ') || 'GUEST'}</div>
          </div>
          <button className="nb-sidebar__signout" onClick={handleSignOut}>SIGN OUT</button>
        </div>
      </aside>
      <main className="nb-main">
        <div className="nb-main__inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
